var map = {
	"./Twig_P4_1.mp3": 85976,
	"./Twig_P4_10.mp3": 86323,
	"./Twig_P4_11.mp3": 37445,
	"./Twig_P4_12.mp3": 69874,
	"./Twig_P4_2.mp3": 2223,
	"./Twig_P4_3.mp3": 23722,
	"./Twig_P4_4.mp3": 48441,
	"./Twig_P4_5.mp3": 41620,
	"./Twig_P4_6.mp3": 93291,
	"./Twig_P4_7.mp3": 32518,
	"./Twig_P4_8.mp3": 6261,
	"./Twig_P4_9.mp3": 25520,
	"./Twig_P5_1.mp3": 5525,
	"./Twig_P5_10.mp3": 14767,
	"./Twig_P5_11.mp3": 52618,
	"./Twig_P5_12.mp3": 90621,
	"./Twig_P5_2.mp3": 95746,
	"./Twig_P5_3.mp3": 679,
	"./Twig_P5_4.mp3": 20844,
	"./Twig_P5_5.mp3": 52529,
	"./Twig_P5_6.mp3": 80094,
	"./Twig_P5_7.mp3": 44035,
	"./Twig_P5_8.mp3": 2200,
	"./Twig_P5_9.mp3": 88541,
	"./alarm.mp3": 39513,
	"./disconnected.mp3": 92960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15900;